import { Component, OnInit, Input } from '@angular/core';
import { IDefaultSpotData } from '../default/default.component';
import { IModalVideo } from 'src/app/shared/components/modal-video/modal-video.component';
import { MqService } from 'src/app/service/mq.service';
import { IPictureData } from 'src/app/shared/components/picture/picture.component';
import get from 'lodash.get';

@Component({
  selector: 'app-video-element',
  templateUrl: './video-element.component.html',
  styleUrls: ['./video-element.component.less']
})
export class VideoElementComponent implements OnInit {
  @Input() data: IDefaultSpotData;

  showingItem: IModalVideo = null;
  isShow: boolean;
  isMobile: boolean;

  constructor(
    private mq: MqService
  ) { }

  ngOnInit() {
    this.mq.mobileDesktop(this.mobile.bind(this), this.desktop.bind(this));
  }

  mobile() {
    this.isMobile = true;
  }
  desktop() {
    this.isMobile = false;
  }

  getThumbnail(item: IDefaultSpotData) {
    const mobileTh = 'media.value.video.mobile.thumbnail';
    const deskTh = 'media.value.video.desktop.thumbnail';

    return this.isMobile ?
      get(item, mobileTh, deskTh) :
      get(item, deskTh, mobileTh);
  }

  open(item: IDefaultSpotData) {
    this.isShow = true;
    this.showingItem = this.modalItemBuilder(item);
  }

  close() {
    this.isShow = false;
    this.showingItem = null;
  }

  modalItemBuilder(item: IDefaultSpotData) {
    const mobileVideo = 'media.value.video.mobile';
    const deskVideo = 'media.value.video.desktop';

    return {
      title: item.title,
      description: item.description,
      video: this.isMobile ?
        get(item, mobileVideo, deskVideo) :
        get(item, deskVideo, mobileVideo)
    };
  }

  // Remove it after app-picture supports string parameter
  createThumbnailData(thumbnail: string): IPictureData {
    return {
      alt: thumbnail,
      height: 900,
      width: 1600,
      src: thumbnail,
      sources: [
        {
          media: ``,
          srcSet: `${thumbnail}?center=0.5,0.5&mode=crop&width=570&height=300`
        },
        {
          media: `(max-width: 1024px)`,
          srcSet: `${thumbnail}?center=0.5,0.5&mode=crop&width=330&height=176`
        },
        {
          media: `(max-width: 860px)`,
          srcSet: `${thumbnail}?center=0.5,0.5&mode=crop&width=700&height=360`
        }
      ]
    };
  }
}
